import { useAppSelector } from '../../../Hooks/useAppSelector'
import { ShipmentSelectors } from '../StoreAdapter'

export const useShipmentsSelector = () => {
  return useAppSelector(ShipmentSelectors.selectEntities)
}
